/* src/app/modules/display/components/menus/product-menu/inflators/product-menu-inflator/product-menu-inflator.component.scss */
/*# sourceMappingURL=product-menu-inflator.component.css.map */
